import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';

import AlertsService from 'cio/services/alerts';
import AnalyticsService from 'cio/services/analytics';
import ApiErrorsService from 'cio/services/api-errors';
import CollectionModel from 'cio/models/collection';
import RouterService from '@ember/routing/router-service';

const DEFAULT_VALUES = {
  showConfirmDeleteModal: false,
  showUpdateModal: false,
};

export default class CollectionController extends Controller {
  @service alerts!: AlertsService;
  @service analytics!: AnalyticsService;
  @service apiErrors!: ApiErrorsService;
  @service router!: RouterService;

  declare model: CollectionModel;

  showConfirmDeleteModal = DEFAULT_VALUES.showConfirmDeleteModal;
  showUpdateModal = DEFAULT_VALUES.showUpdateModal;

  setDefaults() {
    this.setProperties(DEFAULT_VALUES);
  }

  setAttrAndSaveCollectionTask = task({ drop: true }, async (attr: 'name' | 'description', value: string) => {
    let collection = this.model;

    collection.setProperties({
      [attr]: value,
      updateType: attr,
    } as any);

    try {
      await collection.save();
      collection.resetUpdateType();
    } catch (errors) {
      this.apiErrors.report(errors);
      collection.rollbackAttributes();
    }
  });

  deleteTask = task({ drop: true }, async (collection: CollectionModel) => {
    try {
      await collection.destroyRecord();
      this.alerts.success('collection.delete.success', `${collection.name} deleted`);
      this.router.transitionTo('collections');
    } catch (error) {
      this.apiErrors.report(error);
    }

    this.set('showConfirmDeleteModal', false);
  });

  updateTask = task({ drop: true }, async (collection: CollectionModel) => {
    try {
      await collection.save();
      collection.resetUpdateType();
      this.router.transitionTo('collections.collection');
    } catch (error) {
      collection.rollbackAttributes();
      this.apiErrors.report(error);
    }

    this.set('showUpdateModal', false);
  });

  dismissImportErrorTask = task({ drop: true }, async (collection: CollectionModel) => {
    collection.set('updateType', 'clear_error');
    await collection.save();
    collection.resetUpdateType();
  });

  @action
  revealConfirmDeleteModal() {
    this.set('showConfirmDeleteModal', true);
    this.analytics.track('collections', 'delete_started', { model: this.model });
  }

  @action
  revealUpdateModal() {
    this.set('showUpdateModal', true);
    this.analytics.track('collections', 'update_started', { model: this.model });
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'collections/collection': CollectionController;
  }
}
